import { FC, useEffect } from 'react';
import { useAlertsStore } from '../../../stores/alertsStore';
import { AlertInterface } from '../../../interfaces/AlertInterface';
import { callEvent } from '../../../utils/Amplitude/AmplitudeUtilities';
import { useLocationStore } from '../../../stores/locationStore';
import { AlertsDrawerActiveContent } from './AlertsDrawerActiveContent';
import { AlertsDrawerExpiredContent } from './AlertsDrawerExpiredContent';

interface Props {
  alertsDrawerOpen: boolean;
  alertsError: boolean;
  alertsLoading: boolean;
  refetchAlerts: () => void;
  setAlertChildCaseOpen: (val: AlertInterface | undefined) => void;
  showExpiredAlerts: boolean;
  setShowExpiredAlerts: (show: boolean) => void;
}

export const AlertsDrawerContent: FC<Props> = ({
  alertsDrawerOpen,
  alertsError,
  alertsLoading,
  refetchAlerts,
  setAlertChildCaseOpen,
  showExpiredAlerts,
  setShowExpiredAlerts,
}) => {
  const { activeLocation } = useLocationStore();
  const { alertsOutages, expiredAlertsOutages, setAllAlertsDismissed } =
    useAlertsStore();

  const showEmptyStateActive =
    alertsError || alertsLoading || alertsOutages.length === 0;

  const showEmptyStateExpired =
    alertsError || alertsLoading || expiredAlertsOutages.length === 0;

  useEffect(() => {
    if (alertsDrawerOpen) {
      if (!alertsError && !alertsLoading) {
        setAllAlertsDismissed();
      }
      callEvent('view alerts', {});
    }
  }, [alertsDrawerOpen, alertsError, alertsLoading]);

  return !showExpiredAlerts ? (
    <AlertsDrawerActiveContent
      showEmptyState={showEmptyStateActive}
      alertsError={alertsError}
      alertsOutages={alertsOutages}
      setAlertChildCaseOpen={setAlertChildCaseOpen}
      alertsDrawerOpen={alertsDrawerOpen}
      refetchAlerts={refetchAlerts}
      alertsLoading={alertsLoading}
      activeLocation={activeLocation}
      showExpiredAlerts={showExpiredAlerts}
      setShowExpiredAlerts={setShowExpiredAlerts}
    />
  ) : (
    <AlertsDrawerExpiredContent
      showEmptyState={showEmptyStateExpired}
      alertsOutages={expiredAlertsOutages}
    />
  );
};
